export const parseNumberInput = (input: string): number => {
  const parsed = parseInt(input.replace(/[^\d]/g, ''), 10);
  return isNaN(parsed) ? 0 : parsed;
};

export const formatDisplayValue = (
  num: number,
  maxValue: number,
  isFocused: boolean,
  isMax?: boolean,
): string => {
  if (isFocused) return String(num);

  const formatted = new Intl.NumberFormat('de-DE').format(num);
  return num >= maxValue && isMax ? formatted + '+' : formatted;
};
